import {create} from 'zustand/react';
import type {PlaylistInfo} from '../pages/replay/types';

interface IuseReplayStore {
    playListMap: Map<string, Array<PlaylistInfo>>;
    setPlayListMap: (val: Map<string, Array<PlaylistInfo>>) => void;
    showPlayer: boolean;
    selectedVideoId: string;
    handleClick: (val: PlaylistInfo) => void;
    handleClosePlayer: () => void;
    lastFocus: string;
    setLastFocus: (val: string) => void;
}

const useReplayStore = create<IuseReplayStore>((set, get) => ({
    playListMap: new Map(),
    setPlayListMap: (val: Map<string, Array<PlaylistInfo>>) => {
        set({playListMap: val});
    },
    showPlayer: false,
    selectedVideoId: '',
    handleClick: (playlistInfo: PlaylistInfo) => {
        set({showPlayer: true});
        set({selectedVideoId: playlistInfo.snippet.resourceId.videoId});
    },
    handleClosePlayer: () => {
        set({showPlayer: false});
        set({selectedVideoId: ''});
    },
    lastFocus: '',
    setLastFocus: (val: string) => {
        set({lastFocus: val});
    },
}));

export default useReplayStore;
